// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"A0-z"};